import { useState, useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { content } from "@/i18n";
import { pages } from "@/i18nPages";
import { applySeo, initAnalytics } from "@/seo";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import GestionDeProjets from "@/pages/GestionDeProjets";
import AeronautiqueDefense from "@/pages/AeronautiqueDefense";

function ScrollManager({ lang }) {
  const { pathname, hash } = useLocation();
  useEffect(() => { applySeo(lang, pathname); }, [lang, pathname]);
  useEffect(() => {
    if (hash) {
      const id = decodeURIComponent(hash.slice(1));
      const timer = setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: "smooth" }), 50);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  const [lang, setLangState] = useState(() => localStorage.getItem("mkn-lang") || "fr");
  const setLang = (l) => { localStorage.setItem("mkn-lang", l); setLangState(l); };
  const t = { ...content[lang], pages: pages[lang] };

  useEffect(() => { initAnalytics(); }, []);

  return (
    <BrowserRouter>
      <ScrollManager lang={lang} />
      <div className="App">
        <Header t={t} lang={lang} setLang={setLang} />
        <main>
          <Routes>
            <Route path="/" element={<Home t={t} />} />
            <Route path="/gestion-de-projets" element={<GestionDeProjets t={t} />} />
            <Route path="/aeronautique-defense" element={<AeronautiqueDefense t={t} />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </main>
        <Footer t={t} />
        <Toaster position="top-center" />
      </div>
    </BrowserRouter>
  );
}

export default App;
